import { render, staticRenderFns } from "./veStuScholarshipType.vue?vue&type=template&id=22ea51d8&scoped=true"
import script from "./veStuScholarshipType.vue?vue&type=script&lang=js"
export * from "./veStuScholarshipType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ea51d8",
  null
  
)

export default component.exports